import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getShift = (params) => {
    return axios.get(`${backendHost}/api/admin/cashiers/shift/list`, {params});
};

export {
    getShift
}